import { gql } from "@apollo/client";

export const ADD_SCHEDULEDJOB = gql`
    mutation Schedule($scheduleInfo: ScheduleInfoInput!) {
        upsertSchedule(scheduleInfo: $scheduleInfo) {
            id
        }
    }
`;

export const DELETE_SCHEDULE = gql`
    mutation Schedule($companyId: ID!, $scheduleId: ID!) {
        deleteSchedule(companyId: $companyId, scheduleId: $scheduleId)
    }
`;

export const ADD_SCHEDULEHISTORY = gql`
    mutation Schedule($scheduleInput: ScheduledJob!) {
        upsertScheduleHistory(scheduleInput: $scheduleInput)
    }
`;

export const UPSERT_ACTION = gql`
    mutation UpsertAction($type: String, $action: InputPolicyAction) {
        upsertAction(type: $type, action: $action) {
            id
            name
            project {
                id
                name
            }
            filter {
                severity
                includedCis
                includedCiQuery
            }
            evaluationPolicy {
                timeWindow
                numberOfIssues
            }
            roles
        }
    }
`;

export const DELETE_ACTION = gql`
    mutation DeleteAction($actionId: String!) {
        deleteAction(actionId: $actionId)
    }
`;

export const UPSERT_POLICY = gql`
    mutation UpsertPolicy($policy: InputPolicyRel) {
        addPolicyRel(policy: $policy) {
            id
            indexType
            alarmType
            policies {
                name
                policy
            }
        }
    }
`;

export const DELETE_POLICY = gql`
    mutation DeletePolicy($policyRelId: String!) {
        deletePolicy(policyRelId: $policyRelId)
    }
`;

export const DELETE_ACTION_FROM_POLICY = gql`
    mutation DeleteActionFromPolicy($policyRelId: String!, $actionId: String!) {
        deleteActionFromPolicy(policyRelId: $policyRelId, actionId: $actionId)
    }
`;

export const RUN_PROJECT = gql`
    mutation RunProject($companySysId: ID, $projectId: ID, $userInputs: JSON, $taskId: String) {
        runProject(
            autoRequest: {
                companySysId: $companySysId
                projectId: $projectId
                userInputs: $userInputs
                taskId: $taskId
            }
        ) {
            requestId
        }
    }
`;

// Go through SN so automation can be associated with a request item (parentId)
export const RUN_SN_PROJECT = gql`
    mutation RunSNProject($companySysId: ID!, $projectId: ID!, $userInputs: JSON, $parentId: ID) {
        runSNProject(
            autoRequest: {
                companySysId: $companySysId
                projectId: $projectId
                userInputs: $userInputs
                parentId: $parentId
            }
        ) {
            taskId
        }
    }
`;

export const ADD_COMPANY_PARENT = gql`
    mutation addCompanyParent($companySysId: String!, $companiesChildren: [String]!) {
        addCompanyParent(companySysId: $companySysId, companiesChildren: $companiesChildren)
    }
`;

export const DELETE_COMPANY_PARENT = gql`
    mutation deleteCompanyParent($companySysId: String!, $companiesChildren: [String]!) {
        deleteCompanyParent(companySysId: $companySysId, companiesChildren: $companiesChildren)
    }
`;
